/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListMetaMcpServersRequest,
  ListMetaMcpServersSecurity,
} from "../models/operations/listmetamcpservers.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildMetaMcpServersQuery,
  MetaMcpServersQueryData,
  prefetchMetaMcpServers,
  queryKeyMetaMcpServers,
} from "./metaMcpServers.core.js";
export {
  buildMetaMcpServersQuery,
  type MetaMcpServersQueryData,
  prefetchMetaMcpServers,
  queryKeyMetaMcpServers,
};

export type MetaMcpServersQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listMetaMcpServers metaMcp
 *
 * @remarks
 * List meta MCP servers for a project
 */
export function useMetaMcpServers(
  request?: ListMetaMcpServersRequest | undefined,
  security?: ListMetaMcpServersSecurity | undefined,
  options?: QueryHookOptions<MetaMcpServersQueryData, MetaMcpServersQueryError>,
): UseQueryResult<MetaMcpServersQueryData, MetaMcpServersQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildMetaMcpServersQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listMetaMcpServers metaMcp
 *
 * @remarks
 * List meta MCP servers for a project
 */
export function useMetaMcpServersSuspense(
  request?: ListMetaMcpServersRequest | undefined,
  security?: ListMetaMcpServersSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    MetaMcpServersQueryData,
    MetaMcpServersQueryError
  >,
): UseSuspenseQueryResult<MetaMcpServersQueryData, MetaMcpServersQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildMetaMcpServersQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setMetaMcpServersData(
  client: QueryClient,
  queryKeyBase: [
    parameters: {
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    },
  ],
  data: MetaMcpServersQueryData,
): MetaMcpServersQueryData | undefined {
  const key = queryKeyMetaMcpServers(...queryKeyBase);

  return client.setQueryData<MetaMcpServersQueryData>(key, data);
}

export function invalidateMetaMcpServers(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: {
      gramSession?: string | undefined;
      gramKey?: string | undefined;
      gramProject?: string | undefined;
    }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "metaMcp", "list", ...queryKeyBase],
  });
}

export function invalidateAllMetaMcpServers(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "metaMcp", "list"],
  });
}
